import { emphasize } from "@material-ui/core/styles"

const styles = theme => ({
  input: {
    display: "flex",
    padding: 0,
    height: "auto",
    minWidth: 180,
  },
  inputUnderline: {
    "&:before": {
      borderBottom: `1px solid transparent`,
    },
    "&:after": {
      borderBottom: `2px solid transparent`,
    },
    "&:hover:not($disabled):before": {
      borderBottom: `2px solid transparent !important`,
    },
  },
  valueContainer: {
    display: "flex",
    flexWrap: "wrap",
    flex: 1,
    alignItems: "center",
    overflow: "hidden",
    // height: 40,
    // paddingLeft: theme.spacing()
  },
  chip: {
    margin: theme.spacing(0.5, 0.25),
  },
  chipFocused: {
    backgroundColor: emphasize(
      theme.palette.type === "light"
        ? theme.palette.grey[300]
        : theme.palette.grey[700],
      0.08
    ),
  },
  noOptionsMessage: {
    padding: theme.spacing(1, 2),
  },
  singleValue: {
    fontSize: 16,
  },
  placeholder: {
    fontSize: 16,
  },
  paper: {
    position: "absolute",
    zIndex: 1,
    left: 0,
    right: 0,
    width: "170%",
  },
  menuList: {
    paddingTop: [0, "!important"],
    paddingBottom: [0, "!important"],
  },
})

export default styles
